import type {EmploymentsResponse, SelfEmploymentProvider} from '../employment/fetchEmployment';
import {axiosInstance} from '../axiosInstance';

export type BindSelfEmploymentPartnerRequest = {
	provider: SelfEmploymentProvider;
};

/** В ответе — те же поля, что в GET /employment (в т.ч. `selfEmploymentProfiles[].agreement.link`). */
export type BindSelfEmploymentPartnerResponse = Partial<EmploymentsResponse> | null;

/** POST `/executor_web/self_employment/bind_partner` — привязка партнёра в «Мой налог» */
export function bindSelfEmploymentPartner(request: BindSelfEmploymentPartnerRequest, signal?: AbortSignal) {
	return axiosInstance.post<BindSelfEmploymentPartnerResponse>('self_employment/bind_partner', request, {signal});
}
